'use client';
import React from 'react';

export default function PrivacySection() {
  return (
    <section
      className="w-full"
      style={{ backgroundColor: '#EFE3E1', paddingTop: 'clamp(64px, 8vw, 112px)', paddingBottom: 'clamp(64px, 8vw, 112px)' }}
    >
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 clamp(24px, 4vw, 64px)' }}>
        <div className="flex flex-col lg:flex-row items-start gap-12 lg:gap-16">

          {/* Image — full bleed left */}
          <div className="w-full lg:w-5/12 flex-shrink-0">
            {/* Reserved aspect-ratio box prevents layout shift */}
            <div style={{ position: 'relative', width: '100%', aspectRatio: '4 / 5', overflow: 'hidden' }}>
              <img
                src="/assets/images/Screenshot_2026-06-27_at_10.47.53-1783799314562.png"
                alt="Soft blurred grass in natural light — calm and serene outdoor setting"
                style={{
                  position: 'absolute',
                  inset: 0,
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  display: 'block',
                }}
              />
            </div>
          </div>

          {/* Text */}
          <div className="w-full lg:w-7/12 flex flex-col justify-center" style={{ paddingTop: 'clamp(0px, 3vw, 40px)' }}>
            <p
              style={{
                fontFamily: 'adobe-garamond-pro, Georgia, serif',
                fontSize: '11px',
                letterSpacing: '0.16em',
                textTransform: 'uppercase',
                color: '#8A9E8C',
                marginBottom: '16px',
              }}
            >
              Confidentiality &amp; Discretion
            </p>
            <h2
              style={{
                fontFamily: 'orpheus-pro, Georgia, serif',
                fontSize: 'clamp(26px, 3.2vw, 48px)',
                fontWeight: '400',
                color: '#1A2332',
                lineHeight: '1.2',
                marginBottom: '28px',
              }}
            >
              Your privacy is paramount
            </h2>
            <p
              style={{
                fontFamily: 'adobe-garamond-pro, Georgia, serif',
                fontSize: 'clamp(16px, 1.3vw, 19px)',
                color: '#4A4A4A',
                lineHeight: '1.8',
                marginBottom: '36px',
              }}
            >
              All services are bound by professional codes of conduct, so a confidential service is assured. If you require particular discretion around consultations, please don&apos;t hesitate to contact Dr Morgan to discuss further so that confidentiality is maintained.
            </p>

            {/* Three assurance points */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', marginBottom: '40px' }}>
              {[
                'Bound by HCPC professional codes of conduct',
                'Absolute discretion for all consultations',
                'Secure, private practice environment',
              ].map((point, idx) => (
                <div key={idx} className="flex items-start gap-3">
                  <span
                    style={{
                      display: 'inline-block',
                      width: '4px',
                      height: '4px',
                      borderRadius: '50%',
                      backgroundColor: '#8A9E8C',
                      marginTop: '10px',
                      flexShrink: 0,
                    }}
                  />
                  <span
                    style={{
                      fontFamily: 'adobe-garamond-pro, Georgia, serif',
                      fontSize: 'clamp(15px, 1.1vw, 17px)',
                      color: '#4A4A4A',
                      lineHeight: '1.6',
                    }}
                  >
                    {point}
                  </span>
                </div>
              ))}
            </div>

            <a
              href="/contact"
              style={{
                fontFamily: 'adobe-garamond-pro, Georgia, serif',
                fontSize: '14px',
                color: '#1A2332',
                textDecoration: 'none',
                borderBottom: '1px solid rgba(26,35,50,0.35)',
                paddingBottom: '2px',
                display: 'inline-block',
                transition: 'border-color 0.2s ease',
              }}
              onMouseEnter={e => ((e.currentTarget as HTMLElement).style.borderBottomColor = '#1A2332')}
              onMouseLeave={e => ((e.currentTarget as HTMLElement).style.borderBottomColor = 'rgba(26,35,50,0.35)')}
            >
              Discuss your requirements with Dr Morgan →
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
